import {
  SET_PERSON_CATEGORIES,
  SET_PRODUCT_CATEGORIES,
  SET_SERVICE_CATEGORIES,
} from "../../constants/categoryConstants";

export const setPersonCategories = (categories) => {
  return {
    type: SET_PERSON_CATEGORIES,
    categories,
  };
};

export const setProductCategories = (categories, filtered = false) => {
  return {
    type: SET_PRODUCT_CATEGORIES,
    categories,
    filtered,
  };
};

export const setServiceCategories = (categories, filtered = false) => {
  return {
    type: SET_SERVICE_CATEGORIES,
    categories,
    filtered,
  };
};
